// extracted by mini-css-extract-plugin
export default {"navItem":"header_navItem__--ZmO","text":"header_text__dRTzj","icon":"header_icon__e+8Qz","topmenu":"header_topmenu__Dz1Bj"};